var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermsConditions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_475_50434",
    transform: "translate(-0.0555556 -0.0555556) scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_475_50434",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACB0lEQVR4nO3d0UkDQRjE8Xm1Bs8u1BoM9igWES79JL5agciIkCeRI7e3m53NzK+AzX75ByOfBwIRERERERFiSL6S/ODtO5HcQd35oi6OUEczUEczUEczUEczUEczUEczUEczUEczUNdw9i+SbyQfSd71nnMYjWJ8knzqPduQGsT4Jvnce65hNQjy3numoRW84XuS9yvOzza5cZBp5fnZJosFsYKtCl5zXhOFZtAhyKoL0QwSREuCiEkQMQkiJkHEJIiYBBEzwi7LCjoEyepkQYKI6REkuyyxIIuu/R3V2u+P6POHsGj+khes6trfUddA8qF0/pIXq6rC+RPEuAeZlaKcYxxK5y95wapan68uQcQkiJgEEdMjSHZZYkGyy1qQIGJ6BMkuSyzIolF2WVy5oyqdv+RiTS9UcMS0eagGK5HS+Usu1fRCBUdMm4e6fPYEUdllrd1RXarGxZpeiGaQIFoSREyCiOkRJLsssSDZZS1IEDE9gmSXJRZkUYXz93kuSyvIBDHujwFNEOMeZFaKkueyBlfjE9D0QjSDBNGSIGISREyCiEkQMQlyg0FOYr/27t2fy9rVjPLP+WtNm4ca+TGg1hJk/CCz9XNZrdEM1NEM1NEM1NEM1NEM1NEM1NEM1NEM1NEM1NEM1NEM1NEM1OVfHomp/fcWYUeSL73f74iIiIiICPzxA85KpJFsB1HsAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsConditions);
export default __webpack_public_path__ + "static/media/TermsConditions.36353037ffa5c250a03b82fc1cdec45d.svg";
export { ForwardRef as ReactComponent };